import { RootState } from '@center-pwa/store/store';

/**
 * The centered sphere, as committed to Redux from the route.
 *
 * Deliberately does NOT fall back to the user's home sphere. Redux lags the URL by
 * one commit on entry, and consumers key the metaspace grid on this value — with a
 * fallback, the grid mounts against the home sphere, fetches its whole context tree,
 * and is then torn down and remounted when the real sphere lands. Returning '' keeps
 * those consumers gated until the route sphere is committed, so the grid mounts once.
 */
export const selectSphereId = (state: RootState) => {
  return state.sphere.sphereId || '';
};
